/** Shared message box; attachments and submission behavior belong to the caller. */
import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react'
import { Icon } from './Icon'
import './message-composer.css'

type Props = HTMLAttributes<HTMLDivElement> & {
  actions: ReactNode
  compact?: boolean
  onSend?: () => void
  sendDisabled?: boolean
}

export function MessageComposer({ children, actions, compact = false, className = '', onSend,
  sendDisabled, onKeyDown, ...props }: Props) {
  return <div {...props} className={`message-composer${compact ? ' compact' : ''} ${className}`}
    onKeyDown={event => {
      onKeyDown?.(event)
      if (!event.defaultPrevented && event.target instanceof HTMLTextAreaElement &&
          event.key === 'Enter' && (event.metaKey || event.ctrlKey) && onSend) {
        event.preventDefault()
        if (!sendDisabled) onSend()
      }
    }}>
    {children}
    <div className="message-compose-actions">{actions}</div>
  </div>
}

export function MessageSendButton({ label = 'Send message', busy = false, className = '', ...props }:
  ButtonHTMLAttributes<HTMLButtonElement> & { label?: string; busy?: boolean }) {
  return <button type="submit" {...props} className={`primary message-icon-button ${className}`}
    aria-label={label} title={`${label} (⌘/Ctrl+Enter)`} aria-busy={busy}>
    <Icon name="send" size={20} />
  </button>
}
